export const cognitoConfig = {
  region: 'ca-central-1',
  userPoolId: 'ca-central-1_wIuxbBJ06',
  clientId: '5at24p912mlqulksjmp46urk30',
  cognitoDomain: 'https://ca-central-1wiuxbbj06.auth.ca-central-1.amazoncognito.com',
  redirectUri: 'https://app.privacy.education',
  scopes: 'email openid phone',
};

export function getLoginURL(): string {
  const { cognitoDomain, clientId, scopes } = cognitoConfig;
  const redirectUri = window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : 'https://app.privacy.education';
  return `${cognitoDomain}/login?client_id=${clientId}&response_type=token&scope=${encodeURIComponent(scopes)}&redirect_uri=${encodeURIComponent(redirectUri)}`;
}

export function getLogoutURL(): string {
  const { cognitoDomain, clientId } = cognitoConfig;
  const logoutUri = window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : 'https://app.privacy.education';
  return `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}

export function parseJWT(token: string): any {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
  } catch {
    return null;
  }
}

export function getStoredToken(): string | null {
  return localStorage.getItem('pe_id_token');
}

export function isTokenValid(token: string): boolean {
  const payload = parseJWT(token);
  return payload && payload.exp * 1000 > Date.now();
}

export function storeSession(idToken: string): void {
  const payload = parseJWT(idToken);
  if (!payload) return;
  localStorage.setItem('pe_id_token', idToken);
  localStorage.setItem('pe_user_email', payload.email || '');
  const name = [
    payload.given_name || payload['custom:given_name'],
    payload.family_name || payload['custom:family_name']
  ].filter(Boolean).join(' ')
    || payload.name
    || payload.email
    || payload['cognito:username']
    || '';
  localStorage.setItem('pe_user_name', name);
}

export function clearSession(): void {
  localStorage.removeItem('pe_id_token');
  localStorage.removeItem('pe_user_email');
  localStorage.removeItem('pe_user_name');
}

export function getUserEmail(): string {
  return localStorage.getItem('pe_user_email') || '';
}

export function getUserName(): string {
  return localStorage.getItem('pe_user_name') || '';
}

export function getUserGroups(): string[] {
  const token = getStoredToken();
  if (!token) return [];
  const payload = parseJWT(token);
  return payload?.['cognito:groups'] || [];
}

export function getOrgId(): string | null {
  const token = getStoredToken();
  if (!token) return null;
  const payload = parseJWT(token);
  return payload?.['custom:org_id'] || null;
}

export function isOrgAdmin(): boolean {
  const groups = getUserGroups();
  return groups.includes('org_admin') || groups.includes('super_admin');
}

export function isSuperAdmin(): boolean {
  return getUserGroups().includes('super_admin');
}

/** Returns true if user has org access (super_admin bypasses the org requirement). */
export function hasOrgAccess(): boolean {
  if (isSuperAdmin()) return true;
  return !!getOrgId();
}

const DEMO_KEY = 'pe_demo_mode';

export function isDemoMode(): boolean {
  return localStorage.getItem(DEMO_KEY) === '1';
}

export function setDemoMode(on: boolean): void {
  if (on) localStorage.setItem(DEMO_KEY, '1');
  else localStorage.removeItem(DEMO_KEY);
}